import idontloveyou from './i-dont-love-you.mp3';
import panonaman from './panonaman.mp3';
import always from './always.mp3';

import thumbiontloveyou from '../../song-thumb-nail/feel-every-lyrics/i-dont-love-you.png';
import thumbpanonaman from '../../song-thumb-nail/feel-every-lyrics/panonaman.png';
import thumbalways from '../../song-thumb-nail/feel-every-lyrics/always.png';

const feelPlaylist = [
    {
        name: "I don't love you",
        singer: 'Kang Seungyoon & Gummy',
        songwriter: 'Urban Zakapa',
        songSrc: idontloveyou,
        thumbnailURL: thumbiontloveyou,
    },
    {
        name: 'Pano',
        singer: 'Zack Tabudlo',
        songwriter: 'Zack Tabudlo',
        songSrc: panonaman,
        thumbnailURL: thumbpanonaman,
    },
    {
        name: 'Always',
        singer: 'keshi',
        songwriter: 'keshi',
        songSrc: always,
        thumbnailURL: thumbalways,
    },
];

export default feelPlaylist;
